import React from "react";
import styled from "styled-components/macro";
import { PrimaryButton } from "../Buttons/Buttons";
import logoAlchemist from "./logo_alchemist.png";

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px;
  background-color: ${({ theme }) => theme.tertiaryButtonBG};
  border: 1px solid ${({ theme }) => theme.primaryBorder};
  border-radius: 4px;
  margin-bottom: 20px;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

const LogoImage = styled.img`
  width: 24px;
  height: auto;
  flex-shrink: 0;
`;

const BannerText = styled.p`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.primaryTextColor};
  margin: 0;
  white-space: nowrap;
`;

const CTASection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

interface AlchemistInsightsBannerProps {
  onViewDetails: () => void;
}

export const AlchemistInsightsBanner: React.FC<AlchemistInsightsBannerProps> =
  ({ onViewDetails }) => {
    return (
      <BannerContainer>
        <LeftSection>
          <LogoImage src={logoAlchemist} alt="Alchemist AI" />
          <BannerText>Alchemist Insights</BannerText>
        </LeftSection>
        <CTASection>
          <PrimaryButton
            onClick={onViewDetails}
            style={{ height: "32px", padding: "6px 12px" }}
          >
            View Details
          </PrimaryButton>
        </CTASection>
      </BannerContainer>
    );
  };
